import { render, staticRenderFns } from "./showTask.vue?vue&type=template&id=2d9a9f2a&scoped=true&"
import script from "./showTask.vue?vue&type=script&lang=js&"
export * from "./showTask.vue?vue&type=script&lang=js&"
import style0 from "./showTask.vue?vue&type=style&index=0&id=2d9a9f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a9f2a",
  null
  
)

component.options.__file = "showTask.vue"
export default component.exports